import { Button, Card, Icons, Stack } from '@healthinal/ui';
import { useNavigate } from '@tanstack/react-router';
import { HistoryDto, PatientBasicsDto } from '../../../api/generated/model';
import { SubCard } from '../../../components/SubCard.tsx';
import { PatientAddressDisplay } from '../../components/patient-address/PatientAddressDisplay.tsx';
import { HistoryEntry } from './HistoryEntry.tsx';

export function HistoryResidencyChanged({ history, patient }: { history: HistoryDto; patient: PatientBasicsDto }) {
  const navigate = useNavigate();
  return (
    <HistoryEntry history={history} subject={'Wohnort von'} action={'wurde geändert von'} patient={patient}>
      <Card>
        <Stack direction={'row'} gap={10}>
          <Stack direction={'row'} gap={1} flex={1}>
            {history.previousPatientAddress && (
              <>
                <SubCard sx={{ flex: 1 }}>
                  <PatientAddressDisplay patientAddress={history.previousPatientAddress} />
                </SubCard>
                <Icons.ArrowForward sx={{ alignSelf: 'center' }} />
              </>
            )}
            <SubCard sx={{ flex: 1 }}>
              {history.patientAddress && <PatientAddressDisplay patientAddress={history.patientAddress} />}
            </SubCard>
          </Stack>
          <Stack alignItems={'start'}>
            <Button
              endDecorator={<Icons.ArrowForward />}
              onClick={() => navigate({ to: '/patients/$patientId', params: { patientId: history.patientId } })}>
              Zu Personalien
            </Button>
          </Stack>
        </Stack>
      </Card>
    </HistoryEntry>
  );
}
